export class ActiveOlderVaccination {
	id: number = 0;
	citizenExtraId: number = 0;
	fullName?: string;
	gender?: string;
	phone?: string;
	cns?: string;
	identifier?: string;
	birthdate?: string;
	uf?: string;
	city?: string;
	street?: string;
	neighborhood?: string;
	houseNumber?: string;
	countRegisters: number = 0;
}
